import Select from "react-select";
import React, { forwardRef } from "react";
import { Container } from "react-bootstrap";

import {
  FILTER_LABEL,
  MENU_PLACEMENT,
  screenSize,
  PERFORMANCE_FILTER_SELECT_MAX_MENU_HEIGHT,
  STYLES,
} from "../../../constants";
import { Option, ValueContainerForInbox } from "../../../../../shared";
import { filterSelectStyles } from "./styles";

const FilterComponent = forwardRef((props, isGroupChangedRef) => {
  const {
    stores,
    groups,
    showChat,
    windowWidth,
    selectedGroups,
    selectedStores,
    setSelectedGroups,
    setSelectedStores,
  } = props;

  const handleGroupChange = (e) => {
    isGroupChangedRef.current = true;
    if (selectedStores.length) {
      setSelectedStores([]);
    }
    setSelectedGroups(e);
  };

  const handleStoreChange = (e) => {
    //Reset isGroupChangedRef
    isGroupChangedRef.current = false;
    setSelectedStores(e);
  };

  return (
    <Container
      fluid
      data-testid="stores-groups-filter"
      className={`pb-2 ${
        showChat && windowWidth <= screenSize.TABLET && STYLES.D_NONE
      }`}
    >
      <div className="d-md-flex justify-content-between align-items-center gap-2">
        <div className="d-flex align-items-center gap-2 group-and-store-filter">
          <Select
            isMulti
            className="w-100"
            name="Groups"
            value={selectedGroups}
            options={groups?.data || []}
            components={{
              IndicatorSeparator: () => null,
              Option: Option,
              ValueContainer: ValueContainerForInbox,
            }}
            hideSelectedOptions={false}
            closeMenuOnSelect={false}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            onChange={handleGroupChange}
            maxMenuHeight={PERFORMANCE_FILTER_SELECT_MAX_MENU_HEIGHT}
            isSearchable
            placeholder={FILTER_LABEL.ALL_GROUPS}
            menuPlacement={MENU_PLACEMENT.AUTO}
            styles={filterSelectStyles}
          />
          <Select
            isMulti
            className="w-100"
            name="Stores"
            options={stores || []}
            value={selectedStores}
            components={{
              Option: Option,
              IndicatorSeparator: () => null,
              ValueContainer: ValueContainerForInbox,
            }}
            hideSelectedOptions={false}
            closeMenuOnSelect={false}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            onChange={handleStoreChange}
            isSearchable
            maxMenuHeight={PERFORMANCE_FILTER_SELECT_MAX_MENU_HEIGHT}
            menuPlacement={MENU_PLACEMENT.AUTO}
            placeholder={FILTER_LABEL.ALL_STORES}
            styles={filterSelectStyles}
          />
        </div>
      </div>
    </Container>
  );
});

export default React.memo(FilterComponent);
